import { useMantineTheme } from '@mantine/core';
import { palette } from '../theme/palette';

export const useTheme = () => {
  const theme = useMantineTheme();

  return {
    colors: {
      primary: palette.primary,
      secondary: palette.textSecondary,
      success: palette.positive,
      error: palette.negative,
      warning: palette.warning,
      accent: palette.accentDark,
      neutral: palette.neutral,

      chart: {
        primary: palette.primary,
        secondary: palette.accentDark,
        success: palette.chartPositiveMeta,
        error: palette.negative,
        warning: palette.warning,
        info: palette.accentDark,
        purple: palette.primary,
        orange: palette.warning,
        pink: palette.negative,
        teal: palette.accentDark,
        indigo: palette.primaryHover,
      },

      background: {
        primary: palette.surfaceCard,
        secondary: palette.accentBg,
        card: palette.surfaceCard,
        page: palette.surfacePage,
      },

      text: {
        primary: palette.textPrimary,
        secondary: palette.textSecondary,
        muted: palette.textMuted,
      },

      badge: {
        cydBg: palette.tint1,
        cydText: palette.cydBadgeText,
        insightBg: palette.tint2,
        insightText: palette.positive,
      },
    },

    spacing: theme.spacing,
    radius: theme.radius,
    shadows: theme.shadows,
    fontFamily: theme.fontFamily,
    fontSizes: theme.fontSizes,

    getChartColors: (count: number) => {
      const chartColors = [
        palette.primary,
        palette.accentDark,
        palette.chartPositiveMeta,
        palette.primaryHover,
        palette.textSecondary,
        palette.warning,
        palette.negative,
        palette.primaryLight,
      ];

      return chartColors.slice(0, count);
    },
  };
};
